
export const loginDetailsListingGet = (data) => {
    return data.data
}